import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XnFormControlComponent } from './xn-form-control/xn-form-control.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';
import { XnFormComponent } from './xn-form/xn-form.component';
import {PasswordModule} from 'primeng/password';
import { InputPhoneModule } from './input-phone/input-phone.module';
import { InputSwitchModule } from '../input-switch/input-switch-module';
import { CalendarModule } from '../calendar/calendar-module';
import { DropdownModule } from '../dropdown/dropdown-module';
import { CheckboxModule } from '../checkbox/checkbox-module';



@NgModule({
  declarations: [
    XnFormControlComponent,
    XnFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    TranslateModule,
    DropdownModule,
    CalendarModule,
    CheckboxModule,
    PasswordModule,
    InputPhoneModule,
    InputSwitchModule
  ],
  exports: [
    XnFormControlComponent,
    XnFormComponent,
  ]
})
export class XnFormModule { }
